import { Route, Switch } from 'react-router';
import ViewDistricts from './view';
import EditDistrict from './edit';
import CreateDistrict from './create';

const Districts = () => {
  return (
    <Switch>
      <Route exact path='/admin/districts' component={ViewDistricts} />
      <Route exact path='/admin/districts/new' component={CreateDistrict} />
      <Route exact path='/admin/districts/:id' component={EditDistrict} />
    </Switch>
  );
};

export default Districts;
